import { GQLProductFragment, GQLProductStatusType, GQLStoreFragment } from '@theprintbar/graphql';
import { cn, getCurrencyString, getPartnerPortalPrice } from '@theprintbar/shared';
import { Pill } from '../Pill';

interface ProductDetailsProps {
	product?: Pick<GQLProductFragment, 'slug' | 'brand' | 'name' | 'salePrice'> | null;
	small?: boolean;
	hidePrice?: boolean;
	store?: GQLStoreFragment | null;
	status?: GQLProductStatusType;
}

export function ProductDetails({ product, small, hidePrice, store, status }: ProductDetailsProps) {
	return product ? (
		<div className="w-full text-left space-y-2">
			<div className="flex justify-between items-center">
				<div>
					<h5 className="uppercase text-xs whitespace-nowrap">{product.brand.name}</h5>
					<div className="flex justify-between gap-2 items-center">
						<p className={cn('font-display font-light', small ? 'lg:text-lg' : 'text-lg lg:text-xl')}>{product.name}</p>
						{status && (
							<Pill className={status === GQLProductStatusType.Draft ? 'bg-yellow' : 'bg-green'}>
								{status === GQLProductStatusType.Draft ? 'Draft' : 'Live'}
							</Pill>
						)}
					</div>
				</div>
				{!hidePrice && (
					<div className="space-x-1.5 text-sm text-right lg:text-base">
						<p className="mt-0.5">
							From {getCurrencyString(!!store ? getPartnerPortalPrice(product.salePrice, store) : product.salePrice)}
						</p>
						<p className="text-xs">+ Decorations, rush fees</p>
					</div>
				)}
			</div>
		</div>
	) : null;
}
